<template>
   <div>
    <div class="bb">
      <!-- <div class="tt_10 tt_x_10">
        <div class="cente">
          <div class="lbl">
            兑换数量：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入兑换数量" v-model="number">
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            提货地址：
          </div>
          <div class="content">
            <select v-model="selected">
              <option v-for="(option,aa) in address" :key="aa" v-bind:value="aa">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            姓名：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入姓名" v-model="name">
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            联系电话：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入联系电话" v-model="tel" @change="check">
            <p v-if="err" style="color: red;margin: 0;">手机号码不正确</p>
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div><button @click="confirm" style="margin-right:20px">确认</button><button @click="cancel"
            style="background: rgb(152 169 185)">取消</button>
        </div>
      </div> -->
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00" style="margin-right:8px">
          <h4 class="z_15">兑换数量</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right:0">
          <input class="z_15" type="number" placeholder="请输入兑换数量" name="" id="" v-model="number" disabled="disabled"
            style="background:none">
        </div>
      </div>
      <div class="row  tt_x_10 tt_10 b_x" style="padding-left:10px;">
        <div class="col-00" style="margin-right:8px">
          <h4 class="z_15">提货地址</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right:0">
          <select v-model="selected">
            <option v-for="(option,aa) in address" :key="aa" v-bind:value="aa">
              {{ option }}
            </option>
          </select>
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00" style="margin-right:38px">
          <h4 class="z_15">姓名</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right:0">
          <input class="z_15" type="text" placeholder="填写姓名" name="" id="" v-model="name" />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00" style="margin-right:8px">
          <h4 class="z_15">联系电话</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right:0">
          <input class="z_15" type="text" placeholder="填写联系电话" name="" id="" v-model="tel" @change="check" />
        </div>
        <p v-if="err" class="text-left" style="color: red;margin: 0;">手机号码不正确</p>
      </div>
      <div style="margin-top:20px"><button @click="confirm" style="margin-right:20px">确认</button><button
          @click="cancel">取消</button>
      </div>
    </div>
    <pop :show5="showji" message="兑换成功" @editshow="editshow" />
    <pop :show5="show5" message="请正确填写所有信息" @editshow="editshow1" />
    <pop :show5="show6" message="积分不足" @editshow="editshow2" />
  </div>
</template>
<script>
import pop from './popup.vue'
import user_model from '../tool/user_model'
export default {
  data () {
    return {
      showji: false,
      show5: false,
      show6: false,
      selected: '',
      name: '',
      tel: '',
      address: [],
      number: 1,
      err: 0
    }
  },
  components: {
    pop
  },
  props: {
  },
  created () {
  },
  mounted () {
    const info = user_model.getUserinfo()
    // console.log(this.$route.query.id,
    //   this.$route.query.name,
    //   this.$route.query.price_a,
    //   this.$route.query.imgages_max,
    //   this.$route.query.key_value);
    // this.address.push(this.$route.query.key_value)
    this.address = this.$route.query.key_value
    this.address = this.address.split('｜')
    // console.log(this.address);
  },
  methods: {
    editshow () {
      this.showji = false
      this.$router.push('/user_order_list')
    },
    editshow1 () {
      this.show5 = false
    },
    editshow2 () {
      this.show6 = false
    },
    confirm () {
      const info = user_model.getUserinfo()
      // console.log(this.address[this.selected]);
      // console.log(this.number, this.selected, this.name, this.tel, this.err);
      if (this.number != '' && this.selected != '' || this.selected == 0 && this.name != '' && this.tel != '' && this.err == 0) {
        let formdata = new FormData()
        formdata.append('openid', info.openid)
        formdata.append('title', this.$route.query.name)
        formdata.append('describe', '积分兑换')
        formdata.append('content_id', this.$route.query.id)
        // formdata.append('time', this.gettime)
        formdata.append('integral', '-' + this.$route.query.price_a * this.number)
        // console.log(this.content_name, this.gettime);
        this.$api.postAPI(
          "app/mutual/order_integral/?appid=202108&type_id=6001&state=1",
          formData).then(res => {
            if (res.data.code == 200) {
              let data = new FormData()
              data.append('content_id', this.$route.query.id)
              data.append('content_name', this.$route.query.name)
              data.append('number', this.number)
              data.append('integral', this.$route.query.price_a)
              data.append('content_images', this.$route.query.imgages_max)
              data.append('address', this.address[this.selected])
              data.append('username', this.name)
              data.append('telephone', this.tel)
              data.append('openid', info.openid)
              // console.log(this.$route.query.id, this.$route.query.name, this.number, this.$route.query.price_a, this.$route.query.imgages_max, this.selected, this.name, this.tel);
              this.$api.postAPI(`app/mutual/order/?appid=202108&type_id=6001&state=1`, data
              ).then(res => {
                // console.log(res);
                // this.showji = true
                this.$router.push('/user_order_list')
                this.$Message.success("兑换成功！")
              })
              // this.$axios({
              //   method: "POST",
              //   url: "app/mutual/order_integral/?appid=202108&type_id=6001&state=1",
              //   data: formdata,
              // }).then(res => {
              //   // console.log(res);
              //   // console.log(res.data.code);
              //   if (res.data.code == 200) {
              //     let data = new FormData()
              //     data.append('content_id', this.$route.query.id)
              //     data.append('content_name', this.$route.query.name)
              //     data.append('number', this.number)
              //     data.append('integral', this.$route.query.price_a)
              //     data.append('content_images', this.$route.query.imgages_max)
              //     data.append('address', this.address[this.selected])
              //     data.append('username', this.name)
              //     data.append('telephone', this.tel)
              //     data.append('openid', window.localStorage.getItem('openid'))
              //     // console.log(this.$route.query.id, this.$route.query.name, this.number, this.$route.query.price_a, this.$route.query.imgages_max, this.selected, this.name, this.tel);
              //     this.$axios({
              //       method: "POST",
              //       url: `app/mutual/order/?appid=202108&type_id=6001&state=1`,
              //       data: data,
              //       // headers: {
              //       //   'Content-Type': 'application/x-www-form-urlencoded'
              //       // }
              //     }).then(res => {
              //       // console.log(res);
              //       this.showji = true
              //     })
            } else if (res.data.code == 202) {
              // alert('积分不足')
              // this.show6 = true
              this.$Message.error('积分不足')
            }


          }).catch(err => {
            // console.log(err);
          });

      } else {
        // console.log(123);
        // this.show5 = true
        this.$Message.error('请正确填写所有信息')
      }

    },
    cancel () {
      // this.$router.push('/mall_list')
      this.$router.back(-1)
    },
    check () {
      if (!(/^1[34578]\d{9}$/.test(this.tel))) {
        this.err = 1
        // console.log(1);
        return false
      } else {
        this.err = 0
      }
      // console.log(this.err);
    }
  }


}
</script>
<style>
input {
  border: 0;
}
select {
  border-radius: 5px;
  border: 1px solid #777;
  padding: 3px;
  background: none;
}
.cente {
  /* text-align: justify; */
  display: flex;
  width: 100%;
  margin: 10px 0;
}
.cente .lbl {
  flex: 1;
  text-align: left;
  position: relative;
  top: 3px;
  font-size: 15px;
}
.content {
  text-align: left;
  width: 100%;
}
.content input {
  border: 1px solid #bbb;
  padding: 3px 5px;
  border-radius: 5px;
  width: 100%;
}
.content select {
  border: 1px solid #bbb;
  padding: 3px 5px;
  border-radius: 5px;
  width: 100%;
}
.bb {
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
}
.bb button {
  height: 35px;
  width: 100px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/exchange.vue